var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-lg-5 px-md-3 container-fluid"},[_c('div',{staticClass:"card border-0 shadow p-5 my-4"},[_c('panel')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }